import { buildFileTaggingPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateFileTagging = async ({
  aiVersion,
  workflowData,
  codeSnippets,
  stream = false,
  onChunkReceived,
  abortController
}) => {
  if (!aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildFileTaggingPrompt({ codeSnippets, workflowData })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      useCase: 'workflow-from-code',
      aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })

    return response || null
  } else {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'workflow-from-code',
      aiVersion,
      signal: abortController?.signal
    })

    return response || null
  }
}
